import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";

export const NavigationContainer = styled.ul`
    display: flex;
    list-style: none;
    gap: 6px;

    li {
        align-items: center;
        display: flex;
        gap: 6px;
        line-height: normal;

        span {
            color: #006560;
            cursor: pointer;
            font-weight: 600;
            text-transform: capitalize;
        }

        .symbol {
            cursor: default;
            font-size: 22px;
        }
    }
`;

export const Link = styled(RouterLink)`
    color: #006560;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    text-decoration: none;
    text-transform: capitalize;

    &:visited {
        text-decoration: none;
    }

    @media (min-width: 720px) {
        font-size: 16px;
    }

    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 14px;
    }
`;